import { incrementCounter, recordDistribution } from './sentryMetricsService';

const getRouteTag = (path?: string): string => {
  if (typeof path === 'string' && path.trim()) {
    return path;
  }
  if (typeof window === 'undefined') {
    return 'unknown';
  }
  return window.location?.pathname || 'unknown';
};

const getStartupTimeMs = (): number | null => {
  if (typeof performance === 'undefined') {
    return null;
  }
  const navEntries = performance.getEntriesByType?.('navigation');
  if (Array.isArray(navEntries) && navEntries.length > 0) {
    const navEntry = navEntries[0] as PerformanceNavigationTiming;
    if (
      typeof navEntry.loadEventEnd === 'number' &&
      navEntry.loadEventEnd > 0
    ) {
      return navEntry.loadEventEnd;
    }
  }
  if (typeof performance.now === 'function') {
    return performance.now();
  }
  return null;
};

export const trackAppStart = (path?: string): void => {
  const route = getRouteTag(path);
  incrementCounter('app.start', 1, { route });

  const startupTime = getStartupTimeMs();
  if (typeof startupTime === 'number') {
    recordDistribution(
      'app.startup_time',
      startupTime,
      { route },
      'millisecond'
    );
  }
};

export const trackPageView = (path?: string): void => {
  const route = getRouteTag(path);
  incrementCounter('app.page_view', 1, { route });
};
